"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _redux = require("../redux");

var _templateObject, _templateObject2, _templateObject3;

var LanguageSelector = function LanguageSelector(props) {
  var _site$languages, _site$languages$langu;

  var post = props.post,
      onEdit = props.onEdit,
      onTranslate = props.onTranslate;

  var _ref2 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      site = _ref2.cms.site;

  var _ref3 = (0, _react.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      loading = _ref4[0],
      setLoading = _ref4[1];

  var handleTranslate = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, language;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, language = _ref.language;
              setLoading(language);
              _context.next = 4;
              return onTranslate({
                id: id,
                language: language
              });

            case 4:
              setLoading('');

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleTranslate(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(Container, null, site === null || site === void 0 ? void 0 : (_site$languages = site.languages) === null || _site$languages === void 0 ? void 0 : (_site$languages$langu = _site$languages.languages) === null || _site$languages$langu === void 0 ? void 0 : _site$languages$langu.map(function (p) {
    var _post$translations;

    var flag = p.flag && (0, _htmlReactParser.default)(p.flag);

    if (post.language === p.slug) {
      return /*#__PURE__*/_react.default.createElement(Item, {
        key: p.id,
        onClick: function onClick() {
          return onEdit(p.slug);
        }
      }, flag);
    } else if ((_post$translations = post.translations) !== null && _post$translations !== void 0 && _post$translations[p.slug]) {
      return /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
        key: p.id,
        title: "Edit translation",
        mouseEnterDelay: 0.5
      }, /*#__PURE__*/_react.default.createElement(Item, {
        onClick: function onClick() {
          return onEdit(p.slug);
        }
      }, flag, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_icons.EditTwoTone, null))));
    } else {
      var isLoading = loading === p.slug;
      return /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
        key: p.id,
        title: "Add translation",
        mouseEnterDelay: 0.5
      }, /*#__PURE__*/_react.default.createElement(Item, {
        onClick: function onClick() {
          return !isLoading && handleTranslate({
            id: post.id,
            language: p.slug
          });
        }
      }, flag, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_icons.PlusCircleTwoTone, {
        spin: isLoading
      }))));
    }
  }));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n"])));

var Item = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin: 0 10px;\n  cursor: pointer;\n"])));

var IconContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  z-index: 1;\n"])));

var _default = LanguageSelector;
exports.default = _default;